import { fromJS, Map } from 'immutable'
import get from 'lodash/get'

import { SearchRequestData } from '@lyrahealth-inc/shared-app-logic/src/models/searchForCare/SearchForCare'

import { axiosInstance } from '../../../../common/http/axiosInstance'
import { getIsOnsiteEligibleResponseEnabled } from '../../../../data/featureFlags/featureFlagSelectors'

export const SET_ONSITE_PROVIDERS = 'SET_ONSITE_PROVIDERS'
export const setOnsiteProviders = (providers: $TSFixMe) => ({
  type: SET_ONSITE_PROVIDERS,
  providers,
})

export const CLEAR_ONSITE_PROVIDERS = 'CLEAR_ONSITE_PROVIDERS'
export const clearOnsiteProviders = () => ({
  type: CLEAR_ONSITE_PROVIDERS,
})

export const SET_ONSITE_PROVIDERS_LOADING = 'SET_ONSITE_PROVIDERS_LOADING'
export const setOnsiteProvidersLoading = (loading: boolean) => ({
  type: SET_ONSITE_PROVIDERS_LOADING,
  loading,
})

export const SET_IS_ONSITE_ELIGIBLE = 'SET_IS_ONSITE_ELIGIBLE'
export const setIsOnsiteEligible = (isOnsiteEligible: boolean | undefined) => ({
  type: SET_IS_ONSITE_ELIGIBLE,
  isOnsiteEligible,
})

export const getOnsiteProviders = ({ lyraId, data }: { lyraId?: string; data: SearchRequestData }) => {
  return function (dispatch: $TSFixMe, getState: $TSFixMe) {
    const userId = lyraId ?? getState().getIn(['user', 'id'])
    dispatch(setOnsiteProvidersLoading(true))
    return axiosInstance
      .post(`/v1/provider/onsite/${userId}`, data)
      .then((response) => {
        const responseData = get(response, ['data'], Map())
        const isOnsiteEligibleResponseEnabled = getIsOnsiteEligibleResponseEnabled(getState())
        const providers = isOnsiteEligibleResponseEnabled ? responseData.providers ?? responseData : responseData
        const isOnsiteEligible = isOnsiteEligibleResponseEnabled ? responseData.isOnsiteEligible : undefined
        dispatch(setOnsiteProviders(fromJS(providers)))
        if (isOnsiteEligible !== undefined) dispatch(setIsOnsiteEligible(isOnsiteEligible))
        dispatch(setOnsiteProvidersLoading(false))
        return response
      })
      .finally(() => {
        dispatch(setOnsiteProvidersLoading(false))
      })
  }
}
